export class Notification {
  constructor(
    public message: string,
    public severity: string,
    public position?: string,
    public life?: number
  ) {}
}
